import { render, staticRenderFns } from "./DataBuildImportContactToCampaign.vue?vue&type=template&id=d4510db0&scoped=true"
import script from "./DataBuildImportContactToCampaign.vue?vue&type=script&lang=js"
export * from "./DataBuildImportContactToCampaign.vue?vue&type=script&lang=js"
import style0 from "./DataBuildImportContactToCampaign.vue?vue&type=style&index=0&id=d4510db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4510db0",
  null
  
)

export default component.exports